var render = function render(){var _vm=this,_c=_vm._self._c;return _c('skeleton-loading',[_c('ul',{staticClass:"file-list list-unstyled"},_vm._l((_vm.count),function(index){return _c('li',{key:index},[_c('skeleton-square',{attrs:{"box-properties":{
          height: '50px',
          width: '100%',
        },"count":1}})],1)}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }